import React from 'react';
import { Root, createRoot } from 'react-dom/client';
import App from './App';

const root: Root = createRoot(document.getElementById('root'));
root.render(<App />);
